import { staffTimeLogService } from '../services'
import Vue from 'vue'

const user = JSON.parse(localStorage.getItem('user'))
const state = {
  all: {
    filterInitialized: false,
    meta: {},
    month: {},
    year: {},
    filter: {},
    items: {}
  },
  title: 'test title',
  staffTimeLog: {
    staffTimeLogId: 0,
    userId: 0,
    year: 2018,
    month: 9,
    dateSubmitted: '2018-10-04T07:31:04.931Z',
    employmentPercentage: 0,
    status: 0,
    staffTimeLogLines: []
  },
  staffTimeLogReadOnlyList: [],
  staffTimeLogReadOnly: {
    staffTimeLogId: 0,
    userId: 0,
    year: 2018,
    month: 9,
    dateSubmitted: '2018-10-04T07:31:04.931Z',
    employmentPercentage: 0,
    status: 0,
    staffTimeLogLines: []
  }
}

const actions = {
  test ({ commit }) {
    var data = {
      'test': 222
    }

    commit('testFunctionSuccess', data)
  },
  getAll ({ commit }) {
    commit('getAllRequest')
    staffTimeLogService.getAll(state.all.filter)
      .then(
        staffTimeLogs => {
          return staffTimeLogs.result
        }
      )
  },

  getById ({ commit }, id) {
    return staffTimeLogService.getById(id)
      .then(data => {
        return data.result
      })
  },

  getPreviousByUserId ({ commit }, userId) {
    return staffTimeLogService.getPreviousByUserId(userId)
      .then(data => {
        return data.result
      })
  },

  getHistoryByUserId ({ commit }, userId) {
    return staffTimeLogService.getHistoryByUserId(userId)
      .then(data => {
        return data.result
      })
  },

  create ({ commit, dispatch }, staffTimeLog) {
    staffTimeLog.userId = user.userId
    return staffTimeLogService.create(staffTimeLog)
      .then(staffTimeLog => {
        commit('createSuccess', staffTimeLog.result)
        return staffTimeLog.result
      }).catch(error => {
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, staffTimeLog) {
    return staffTimeLogService.update(staffTimeLog)
      .then(staffTimeLog => {
        commit('updateSuccess', staffTimeLog.result)
        return staffTimeLog.result
      }).catch(error => {
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('deleteRequest', id)

    staffTimeLogService.delete(id)
      .then(staffTimeLog => commit('deleteSuccess', id))
  },

  // Get days in month if no previous data submitted
  // To calculation inline and footer functions https://codepen.io/jjelic/pen/yevNLZ
  generateStaffTimeLogLines ({ commit }) {
    var today = new Date()
    var d = new Date(today.getFullYear(), today.getMonth() - 1, 1)
    // Set date to previous month
    d.setDate(d.getDate() - 1)
    var year = d.getFullYear()
    var month = d.getMonth()
    // 1. Check previous existing previous
    staffTimeLogService.getByUserIdAndYearMonth(user.userId, year, month)
      .then(
        data => {
          if (data.staffTimeLogId > 0) {
            commit('getByUserIdAndYearMonthSuccess', data.result)
          }
        }
      )
    if (state.staffTimeLogId > 0) {
      // state.staffTimeLog = existing
    } else {
      // 2. If not exist, generate new data
      var date = new Date(year, month, 1)
      var days = []
      state.staffTimeLog.userId = user.userId
      state.staffTimeLog.year = year
      state.staffTimeLog.month = month
      while (date.getMonth() === month) {
        days.push(new Date(date))
        date.setDate(date.getDate() + 1)
      }
      for (var i = 0; i < days.length; i++) {
        state.staffTimeLog.staffTimeLogLines.push({
          staffTimeLogLineId: 0,
          staffTimeLogId: 0,
          day: i + 1,
          standardOfService: 7,
          overtimeHours: 0,
          sickLeaveHours: 0,
          qualifyingHours: 0,
          childCareHours: 0,
          offDutyHours: 0,
          vacationDay: 'None'
        })
      }
    }
  },
  getReadOnlyList ({commit}) {
    // Get listing for dropdown menu option to select staff time log readonly
    staffTimeLogService.getReadOnlyListByUserId(user.userId)
      .then(
        data => {
          commit('getReadOnlyListByUserIdSuccess', data)
        }
      )
  },
  getStaffTimeLogInfo ({commit}, year, month) {
    // Get 1 record read only information
    staffTimeLogService.getByUserIdAndYearMonth(user.userId, year, month)
      .then(
        data => {
          commit('getReadOnlyInfoByUserIdAndYearMonthSuccess', data.result)
        }
      )
  }
}

const mutations = {
  // Get all
  getAllRequest (state) {
    state.all.loading = true
  },
  getAllSuccess (state, staffTimeLogs) {
    state.staffTimeLog = staffTimeLogs
  },
  getAllFailure (state, error) {
    state.all.error = error
  },
  getByIdSuccess (state, data) {
    state.staffTimeLog = data
  },

  // Create
  createSuccess (state, updatedStaffTimeLog) {
    state.staffTimeLog = updatedStaffTimeLog
    // state.staffTimeLog = state.staffTimeLog.map(staffTimeLog =>
    //   staffTimeLog.staffTimeLogId === updatedStaffTimeLog.staffTimeLogId ? updatedStaffTimeLog : staffTimeLog
    // )
    Vue.prototype.$toast('Kontakt skapad')
  },
  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa kontakt')
  },

  // Update
  updateSuccess (state, updatedStaffTimeLog) {
    state.staffTimeLog = updatedStaffTimeLog
    // state.staffTimeLog = state.staffTimeLog.map(staffTimeLog =>
    //   staffTimeLog.staffTimeLogId === updatedStaffTimeLog.staffTimeLogId ? updatedStaffTimeLog : staffTimeLog
    // )

    Vue.prototype.$toast('Kontakt uppdaterad')
  },
  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera kontakt')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to staffTimeLog being deleted
    state.staffTimeLog = state.staffTimeLog.map(staffTimeLog =>
      staffTimeLog.id === id
        ? { ...staffTimeLog, deleting: true }
        : staffTimeLog
    )
  },
  deleteSuccess (state, id) {
    // remove deleted staffTimeLog from state
    state.staffTimeLog = state.staffTimeLog.filter(staffTimeLog => staffTimeLog.id !== id)
  },
  getByUserIdAndYearMonthSuccess (state, data) {
    state.staffTimeLog = data
  },
  getReadOnlyListByUserIdSuccess (state, data) {
    state.staffTimeLogReadOnlyList = data
  },
  getReadOnlyInfoByUserIdAndYearMonthSuccess (state, data) {
    state.staffTimeLogReadOnly = data
  }
}

export const staffTimeLogs = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/stafftimelog.module.js